import React from "react";
import WeaTextareaNormal from "../base/wea-textarea-normal";
import WeaTextareaLocale from "../base/wea-textarea-locale";
import { callApi } from "../wea-tools/callApi";
import middleware from "../../middleware";
import WeaTextAreaAuth from "../base/wea-textarea-auth";
import {
  desensitization,
  encryption,
  replaceEncryption
} from "../wea-tools/Encry.base";
class main extends React.Component {
  static defaultProps = {
    inputType: "NORMAl",
    className: "",
    style: {},
    overlayClassName: ""
  };
  static propTypes = {
    inputType: React.PropTypes.string
  };
  componentDidMount() {
    const isMulti = window.localStorage.getItem("activeLanguageIds");
    if (this.props.inputType.toUpperCase() === "MULTILANG") {
      if (isMulti === null) {
        callApi("/api/system/language/base/getActiveLanguage", "GET").then(
          res => {
            if (res.activeLanguageIds)
              window.localStorage.setItem(
                "activeLanguageIds",
                JSON.stringify(res.activeLanguageIds)
              );
          }
        );
      }
    }
  }
  setValue(v = "") {
    this.refs.textareaNormal && this.refs.textareaNormal.setValue(v);
    this.multilang && this.multilang.setValue && this.multilang.setValue(v);
  }
  focus = () => {
    this.form && this.form.focus && this.form.focus();
    this.multilang && this.multilang.focus && this.multilang.focus();
    this.refs.textareaNormal &&
      this.refs.textareaNormal.focus &&
      this.refs.textareaNormal.focus();
  };
  render() {
    const { children, ...resProps } = this.props;
    const { inputType, ecId } = resProps;
    let isMulti = window.localStorage.getItem("activeLanguageIds") || "[7]";
    try {
      isMulti = JSON.parse(isMulti);
    } catch (error) {
      isMulti = [];
      console.error("获取多语言配置信息失败", error);
    }
    let value = resProps.value;
    if (desensitization(value)) {
      return [
        <WeaTextAreaAuth
          className="wea-textarea-normal wea-field-readonly"
          {...resProps}
          ecId={`${this.props.ecId || ""}_WeaTextareaAuth@06v4ui`}
        />,
        children
      ];
    }
    if (encryption(value)) {
      value = replaceEncryption(value);
    }
    if (inputType.toUpperCase() == "FORM") {
      return [
        <input
          ecId={`${ecId}_input@zheryx`}
          ref={ref => (this.form = ref)}
          class={this.props.className}
          style={this.props.style}
        />,
        children
      ];
    }
    if (inputType.toUpperCase() === "MULTILANG" && isMulti.length > 1) {
      return [
        <WeaTextareaLocale
          ref={ref => (this.multilang = ref)}
          {...resProps}
          ecId={`${ecId}_WeaTextareaLocale@gu1lgm`}
        />,
        children
      ];
    }
    return [
      <WeaTextareaNormal
        ref="textareaNormal"
        {...resProps}
        ecId={`${ecId}_WeaTextareaNormal@fjf7xb`}
      />,
      children
    ];
  }
}

const Com = middleware(main, "WeaTextarea");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-textarea/index.js